import { TwSolicitudJerarquiaExViewModel } from '../datosbasicos/datosbasicosEx.types';

export class SolicitudReexportacionViewModel {
    public Id: number;
    public IdEstadoSolicitudEx = 0;
    public IdTipoSolicitudEx: number;
    public IdEstadoSolicitudExDescripcion: string;
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion: string;
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public IdTipoSolicitudExDescripcion: string;
    public CodigoTipoSolicitud: string;
    public CodigoSolicitud: string;
    //public EsPrevia: boolean;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;

    public TReexportacion: TReexportacionViewModel;
    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
}

export class TReexportacionViewModel {
    //public Id: number;
    public IdSolicitudEx: number;
    public NumCertificadoReex = '';
    public Empacados: boolean;
    public Reempacados: boolean;
    public EnvaseOriginal: boolean;
    public EnvaseNuevo: boolean;
    public CertFitoOriginal: boolean;
    public InspAdicional: boolean;
    public Original: boolean;
    public CopiaFielCertificada: boolean;
}
